import React from 'react';

interface SVGProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  strokeColor?: string;
  strokeWidth?: number;
}

export const CircleIcon: React.FC<SVGProps> = ({ 
  className = "", 
  width = 24, 
  height = 24,
  strokeColor = "#D4D4D8",
  strokeWidth = 2
}) => (
  <svg 
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <circle 
      cx="12" 
      cy="12" 
      r="11" 
      stroke={strokeColor} 
      strokeWidth={strokeWidth}
    />
  </svg>
);
